import React, { useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { EXCEL_FILE_SIZE, EXCEL_FILE_SUPPORTED_FORMATS, gridSpacing } from "../../../store/constants";
import { Button, CircularProgress, Grid } from "@mui/material";
import TextField from "../../../utils/ui-components/FormsUI/TextField";
import FileUpload from "../../../utils/ui-components/FormsUI/fileUpload/file-upload.component";
import { ContactService } from "../../../assets/_services/contact-service";
import { openSuccessDialog } from "../../../utils/ui-components/pop-ups/SuccessDialog";
// import { ContactValues } from '.';
import SampleFileDowload from "../../../utils/ui-components/SampleFileDownload";
import { ContactValues } from "./contact-list";

AddContact.propTypes = {
  initialItem: PropTypes.object.isRequired,
  setOpen: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  initialData: PropTypes.object,
};

function AddContact({ initialItem, setOpen, fetchData, initialData }: any) {
  const [isLoading, setIsLoading] = useState(false);

  const FORM_VALIDATION = Yup.object().shape({
    contactName: Yup.string().required("Please enter name for the contact"),
    numberFile: Yup.mixed()
      .nullable()
      .notRequired()
      .test("FILE_SIZE", "The size of uploaded files exceeds the maximum limit of 15MB.", (value: any) => {
        return (
          value?.reduce((accumulator: any, curValue: any) => {
            return accumulator + curValue.size;
          }, 0) <= EXCEL_FILE_SIZE
        );
      })
      .test("FILE_FORMAT", "Only .xlsx, .xls, and .csv, files are allowed.", (value: any) =>
        !value.length ? true : value?.filter((obj: any) => EXCEL_FILE_SUPPORTED_FORMATS.includes(`${obj?.type?.split(".")[0]}`)).length
      ),
  });

  const createContact = (itemData: ContactValues, setSubmitting: (isSubmitting: boolean) => void) => {
    setIsLoading(true);

    var formData = new FormData();
    formData.append("file", itemData.numberFile[0]);
    formData.append("contact_list_name", itemData.contactName);

    if (initialData.role === 1) {
      formData.append("companyId", initialData.creator);
    }

    ContactService.createContactList(formData).then((response) => {
      setSubmitting(false);
      if (response.isSuccess) {
        openSuccessDialog("Success", response.data.comment);
        setOpen(false);
        fetchData("");
      } else {
        setIsLoading(false);
      }
    });
  };

  return (
    <Formik
      initialValues={{
        ...initialItem,
      }}
      validationSchema={FORM_VALIDATION}
      onSubmit={(values: ContactValues, { setSubmitting }) => {
        createContact(values, setSubmitting);
      }}
    >
      {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
        <Form>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
              <TextField required type="text" name="contactName" label="Contact Name" />
            </Grid>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <FileUpload
                accept=".xls,.xlsx,text/csv"
                label="Number File Upload"
                maxFileSizeInBytes={EXCEL_FILE_SIZE}
                name="numberFile"
                customHandleChange={(files: any) => {}}
                limit={"15 MB"}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={10}>
              <SampleFileDowload />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  py: 2,
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  onClick={() => {
                    setOpen(false);
                  }}
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
                <Button color="primary" variant="contained" type="submit" disabled={!dirty || isSubmitting || !isValid}>
                  {isLoading && <CircularProgress size={"20px"} sx={{ mr: 1, color: "gray" }} />} Save Number Base
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default AddContact;
